import React, { useState, useEffect } from 'react';
import { useData, useTexts } from '../data';
import { formatText } from '../constants/texts';

const Footer = () => {
  const { time } = useData();
  const TEXTS = useTexts();
  const [currentyear] = useState(new Date().getFullYear());
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="mt-2 px-3" data-component="Footer">
      <div className="py-2">
        <div className="row">
          <div className="col">
            <div className="text-center mb-2">
              <a
                href="https://kondarangihills.com/app/2025"
                className="btn btn-sm btn-outline-primary"
                target="_blank"
                rel="noreferrer"
              >
                {TEXTS.PREVIOUS_YEAR_LINK}
              </a>
            </div>

            <div className="footer-note mb-1">
              <p className="m-0 text-center small">
                <strong className="color">{TEXTS.NOTE_LABEL}</strong>{' '}
                <span className="text-dark">
                  {formatText(TEXTS.NOTE_TEXT, { year: time?.appYear })}
                </span>
              </p>
            </div>

            <div className="footer-links text-center mb-1">
              <p className="m-0 text-muted" style={{ fontSize: '0.65rem' }}>
                &copy; {currentyear} {TEXTS.COPYRIGHT}{' '}
                <a
                  href="https://vijay.pro/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  விஜயகுமார் S
                </a>
                {' & '}
                <a
                  href="https://kkeeranur.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  K கீரனூர்
                </a>
                {' | v'}
                {process.env.APP_VERSION}
              </p>
            </div>

            <div className="data-refresh-section text-center">
              <small
                className={`datarefresh ${time?.hostname === 'api.kondarangihills.com' ? 'text-success' : 'text-muted'}`}
              >
                {formatText(TEXTS.DATA_REFRESH, { timestamp: time?.timestamp })}
              </small>
            </div>

            <div className="text-center mt-2">
              <small className="text-muted">
                {TEXTS.RECAPTCHA_NOTICE}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  {TEXTS.PRIVACY_POLICY}
                </a>
                {' and '}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  {TEXTS.TERMS_OF_SERVICE}
                </a>
                {TEXTS.RECAPTCHA_APPLY}
              </small>
            </div>

            {showBackToTop && (
              <div className="text-center mt-2">
                <button
                  className="back-to-top-btn"
                  onClick={scrollToTop}
                  title="Back to top"
                >
                  ↑
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
